<template>
  <div>
    <el-dialog
      v-if="visible"
      v-el-dialog-drag
      append-to-body
      show-close
      visible
      width="1200px"
      title="更新车辆信息"
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
      class="set-vehicle-dialog"
    >
      <Main
        ref="main"
        :listSoBillCode="listSoBillCode"
        :listSoBillDetailCode="listSoBillDetailCode"
        @reload="$emit('reload')"
        @close="close()"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.main.cancel()">
          取消
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.confirm()">
          更新
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    listSoBillCode: { type: Array, default: () => [] },
    listSoBillDetailCode: { type: Array, default: () => [] },
    visible: { type: Boolean, default: false },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style lang="scss">
.set-vehicle-dialog {
  .el-dialog__body {
    padding-top: 0 !important;
  }
}
</style>
